import { Link, useNavigate } from "react-router-dom";
import { Bell, Car, Headphones, LogOut, Plus, LayoutGrid, Shield, ShoppingBag } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useVehicles } from "@/context/VehicleContext";
import { BrandLogo } from "@/components/BrandLogo";

export function ConsoleShell({ children, title }) {
  const { user, logout } = useAuth();
  const { notifications } = useVehicles();
  const unread = notifications.filter((n) => !n.read).length;

  return (
    <div className="min-h-screen bg-void text-white relative" style={{ overflowX: "clip" }}>
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)",
          backgroundSize: "56px 56px",
          maskImage: "radial-gradient(ellipse at top, #000 25%, transparent 70%)",
          WebkitMaskImage: "radial-gradient(ellipse at top, #000 25%, transparent 70%)",
        }}
      />
      <header className="sticky top-0 z-30 border-b border-white/10 bg-void/85 backdrop-blur-xl">
        <div className="mx-auto max-w-[1500px] px-6 lg:px-10 h-16 flex items-center justify-between">
          <Link to="/console" className="flex items-center gap-3">
            <BrandLogo compact />
            {title && (
              <span className="hidden md:inline text-sm text-mymech-grey ml-1">
                / {title}
              </span>
            )}
          </Link>
          <div className="flex items-center gap-2 md:gap-3">
            <Link
              to="/console"
              className="hidden md:inline-flex items-center gap-2 h-9 px-3 border border-white/15 text-white/70 font-mono-tech text-[10px] uppercase tracking-widest hover:border-cyan-electric hover:text-cyan-electric"
            >
              <LayoutGrid className="h-3.5 w-3.5" /> showroom
            </Link>
            <Link
              to="/console/marketplace"
              className="hidden md:inline-flex items-center gap-2 h-9 px-3 border border-white/15 text-white/70 font-mono-tech text-[10px] uppercase tracking-widest hover:border-cyan-electric hover:text-cyan-electric"
            >
              <ShoppingBag className="h-3.5 w-3.5" /> marketplace
            </Link>
            {user?.role === "admin" && (
              <Link
                to="/console/admin"
                className="inline-flex items-center gap-2 h-9 px-3 border border-mclaren/50 bg-mclaren/10 text-mclaren font-mono-tech text-[10px] uppercase tracking-widest hover:bg-mclaren/20"
              >
                <Shield className="h-3.5 w-3.5" /> admin
              </Link>
            )}
            {["admin", "sales"].includes(user?.role) && (
              <Link
                to="/console/sales"
                className="inline-flex items-center gap-2 h-9 px-3 border border-cyan-electric/40 bg-cyan-electric/10 text-cyan-electric font-mono-tech text-[10px] uppercase tracking-widest hover:bg-cyan-electric/20"
              >
                <Headphones className="h-3.5 w-3.5" /> sales desk
              </Link>
            )}
            <Link
              to="/console/garage"
              className="inline-flex items-center gap-2 h-9 px-3 border border-white/15 text-white/70 font-mono-tech text-[10px] uppercase tracking-widest hover:border-cyan-electric hover:text-cyan-electric"
            >
              <Car className="h-3.5 w-3.5" /> garage
            </Link>
            <Link
              to="/console/register"
              className="inline-flex items-center gap-2 h-9 px-3 bg-mclaren text-void font-mono-tech text-[10px] uppercase tracking-widest hover:bg-sunset"
            >
              <Plus className="h-3.5 w-3.5" /> register
            </Link>
            <Link
              to="/console/garage"
              className="relative h-9 w-9 inline-flex items-center justify-center border border-white/15 text-white/60 hover:text-cyan-electric"
              title="Notifications"
            >
              <Bell className="h-4 w-4" />
              {unread > 0 && (
                <span className="absolute -top-1 -right-1 h-4 min-w-4 px-1 rounded-full bg-mclaren text-void text-[9px] font-mono-tech flex items-center justify-center">
                  {unread}
                </span>
              )}
            </Link>
            <span className="hidden sm:inline text-sm text-white/50 max-w-[120px] truncate">
              {user?.name || user?.email}
            </span>
            <button
              onClick={logout}
              className="h-9 px-3 border border-white/15 text-white/60 hover:border-mclaren hover:text-mclaren"
            >
              <LogOut className="h-3.5 w-3.5" />
            </button>
          </div>
        </div>
      </header>
      <div className="relative">{children}</div>
    </div>
  );
}

export default ConsoleShell;
